import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { IMSId, IMSObject, IMSObjectType } from 'src/app/_model/ims-object';
import { AlertService } from '../../alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';

@Injectable({
  providedIn: 'root',
})
export class PhotoGalleryActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'photogallery';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private clientStateService: ClientStateService,
    private alertService: AlertService,
    private navigationController: NavController,
    private router: Router
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(
      this.constructor.name,
      'PhotoGalleryActionHandler with params',
      params
    );
    let targetRef = params['targetRef'] ?? 'ims/ServiceJob';
    let targetObj = params['targetObj']
      ? JSON.parse(params['targetObj'])
      : undefined;
    let targetId = this.loadObjIdForTargetRef(targetRef, targetObj);

    const navOptions: NavigationOptions = {
      queryParams: {
        customBackUrl: this.router.url,
        targetRef: targetRef,
        targetId: JSON.stringify(targetId),
      },
    };
    this.navigationController.navigateForward(
      `/feature/photo-gallery`,
      navOptions
    );
  }

  // Private Functions
  private loadObjIdForTargetRef(
    targetRef: IMSObjectType,
    providedObj?: IMSObject
  ): IMSId {
    this.logger.log(this.constructor.name, 'loadObjIdForTargetRef', targetRef);
    let targetId: IMSId;
    switch (targetRef) {
      case 'ims/Branch':
        this.logger.log(
          this.constructor.name,
          'loadObjIdForTargetRef is of type branch',
          this.clientStateService.theState.getValue()
        );
        targetId = this.clientStateService.theState.getValue()?.branchId;

        break;
      case 'ims/TourStop':
        this.logger.log(
          this.constructor.name,
          'loadObjIdForTargetRef is of type tourstop',
          this.clientStateService.theState.getValue()
        );
        targetId = this.clientStateService.theState.getValue()?.tourStopId;

        break;
      case 'ims/DeficiencyTicket':
        this.logger.log(
          this.constructor.name,
          'loadObjIdForTargetRef is of type DeficiencyTicket',
          this.clientStateService.theState.getValue()
        );
        targetId =
          this.clientStateService.theState.getValue()?.deficiencyTicketId;
        break;
      case 'ims/Pin':
        this.logger.log(
          this.constructor.name,
          'loadObjIdForTargetRef is of type Pin - use provided objId as pin is nota available in clientstate'
        );
        targetId = providedObj.id;
        break;
      case 'ims/ServiceJob':
      default:
        this.logger.log(
          this.constructor.name,
          'loadObjIdForTargetRef is of type servicejob/default'
        );
        targetId = this.clientStateService.theState.getValue()?.serviceJobId;
        break;
    }
    this.logger.log(
      this.constructor.name,
      'loadObjIdForTargetRef found id',
      targetId
    );
    return targetId;
  }
}
